import React, { FC, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { Props } from 'react-pdf/dist/Document';

// import { PDFDocumentProxy } from "pdfjs-dist";
import './index.scss';

interface IDocumentViewModal extends Props {
  isOpen: boolean;
  onClose: () => void;
}

const DocumentViewModal: FC<IDocumentViewModal> = (props) => {
  const [numPages, setNumPage] = useState<number>();
  const { isOpen, onClose, ...documentProps } = props;

  const onDocumentLoadSuccess = ({ numPages }: any) => setNumPage(numPages);

  return isOpen ? (
    <div className="document-view-modal">
      <div className="document-view-modal__background" onClick={onClose} />
      <div className="document-view-modal__close" onClick={onClose}>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path
            d="M30 10L10 30"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 10L30 30"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <Document
        {...documentProps}
        file={`data:application/pdf;base64,${documentProps.file}`}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} width={800} />
        ))}
      </Document>
    </div>
  ) : null;
};

export default DocumentViewModal;
